import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAxios from '../../../hooks/useAxios';
import {
  getSpeakingRubric,
  putSpeakingRubric,
} from '../../../api/newSpeaking.api';
import {
  IGetSpeakingRubric, IPostSpeakingRubricReq,
} from '../../../models/newSpeaking.model';
import { useHistory, useRouteMatch } from 'react-router-dom';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import SpeakingRubricEditor from '../../../components/cbt/speaking-rubric/SpeakingRubricEditor';
import useNotification from '../../../hooks/useNotification';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';

interface IMatch {
  id: string;
}

const CbtSpeakingRubricEdit: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const {
    params: { id },
  } = useRouteMatch<IMatch>();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSpeakingRubric>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios<IGetSpeakingRubric>();

  useEffect(() => {
    execute(getSpeakingRubric(id));
  }, []);

  useEffect(() => {
    if (submitRes) {
      successNotification(t('common.message.save1'));
      history.push('/cbt/speaking-rubric');
    }
  }, [submitRes]);

  const submit = (req: IPostSpeakingRubricReq) => {
    submitExecute(putSpeakingRubric(id, req));
  };

  return (
    <div className="content scrollbar">
      {(isLoading || submitIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-cbt-big.svg"
        parentMenu={t('common.menu.cbt')}
        currentMenu={t('cbt.speakingRubric.11')}
      />
      <SpeakingRubricEditor
        data={res?.data}
        submit={submit}
      />
    </div>
  );
};

export default CbtSpeakingRubricEdit;
